/* Svensk katalog for locale-invoice-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'control.expand': 'Förstora chatten',
  'control.collapse': 'Gör chatten mindre',
  'control.proposalIncomplete': 'Fakturaförslaget är ofullständigt. Rader och detaljer har inte fyllts i. Ange det som saknas eller slutför i formuläret.',
  'control.reloadRequired': 'Fakturaläget har uppdaterats. Ladda om sidan innan du fortsätter. Inga fält ändrades.',
  'control.fieldsApplied': 'Kunden och fakturaraderna har fyllts i formuläret. Utkastet har inte sparats.',
  'control.customerApplied': 'Kunden är vald i fakturaformuläret.',
  'control.onepageApplied': 'Visningen har ändrats till allt på en sida.',
  'control.stepsApplied': 'Visningen har ändrats till stegvis ifyllning.',
  'control.editorOpened': 'Sidan för ny försäljning är öppnad.',
  'control.listOpened': 'Fakturalistan är öppnad.',
  'control.saveReady': 'Utkastet kan sparas när du ber mig om det.',
  'control.noChange': 'Inga fält ändrades. Beskriv vad du vill lägga in på fakturan.',
  'control.title': 'SuperPlumma gör jobbet',
  'control.scope': 'Vad vill du göra?',
  'control.you': 'Du',
  'control.input': 'Vad vill du göra?',
  'control.run': 'Utför',
  'control.speak': 'Tal',
  'control.stopMic': 'Avbryt tal',
  'control.stop': 'Stoppa',
  'control.minimize': 'Minimera assistenten',
  'control.newChat': 'Starta ny konversation',
  'control.working': 'Plumme arbetar …',
  'control.saved': 'Utkastet är sparat. Fakturan har inte skickats.',
  'control.reviewHelp': 'Kontrollera fakturan i förhandsgranskningen. Använd «Skapa faktura» och det vanliga sändningsvalet för att slutföra.',
  'control.save': 'Spara utkast',
  'control.listening': 'Lyssnar …',
  'control.voiceUnsupported': 'Den här webbläsaren stöder inte tal här. Du kan fortfarande skriva.',
  'control.voiceFailed': 'Talet kunde inte kännas igen. Kontrollera mikrofonåtkomsten eller skriv meddelandet.',
  'control.editorUnavailable': 'Fakturaredigeraren är inte tillgänglig. Öppna fakturan och försök igen.',
  'control.editorChanged': 'Fakturan ändrades medan jag arbetade. Be om ändringen igen, så använder jag de senaste fälten.',
  'control.invoiceOnly': 'Det här läget stöder fakturor. Använd den vanliga assistenten för andra uppgifter.',
  'control.agentUnavailable': 'Fakturaläget behöver den nya assistenttjänsten. Den är inte tillgänglig just nu. Ingen ändring gjordes.',
  'control.advancedInvoice': 'Den här fakturan har detaljer som måste redigeras i formuläret i första versionen. Inga fält ändrades.',
  'control.customerRequired': 'Välj en befintlig kund eller skapa kunden i kundregistret först.',
  'control.incomplete': 'Välj en kund och lägg till en fakturarad innan du sparar.',
  'control.saveBeforeLeaving': 'Spara utkastet innan du går till fakturalistan, så behåller du ändringarna.',
  'control.failed': 'Uppgiften kunde inte slutföras. Försök igen.',
  'pageControl.working': 'Arbetar på sidan ...',
  'pageControl.done.applied': 'Fälten har uppdaterats på den vanliga sidan.',
  'pageControl.done.saved': 'Åtgärden har slutförts via sidans vanliga sparflöde.',
});
